import { Chart } from '@frontend/chart/types';

export const VENDING_PACKAGE_VOLUME_HOUR_BAR_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'Consumption volume',
            data: Array.from({ length: 24 }, (_, hour) => ({
                label: `${String(hour).padStart(2, '0')}:00`,
                value: Math.max(0, Math.round(8 + Math.sin((hour - 8) / 3) * 14 + (hour >= 7 && hour <= 9 ? 18 : 0) + (hour >= 12 && hour <= 13 ? 12 : 0)))
            }))
        }
    ]
};
